<template>
  <div class="w-full flex flex-col items-center">
      <div
        v-if="showModal"
        @click.self="closeModal"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      >
        <div class="bg-white rounded-lg overflow-hidden relative w-full max-w-3xl mx-4 sm:mx-6 lg:mx-8">
          <button
            @click="closeModal"
            class="absolute top-4 right-4 z-50 text-white hover:text-gray-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div class="relative" style="padding-bottom: 56.25%; height: 0;">
            <iframe
              :src="embedUrl"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
              class="absolute top-0 left-0 w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout-container bg-white min-h-screen flex flex-col md:flex-row">
      <div
      :class="[
          'flex flex-col text-white sticky top-0 z-20 transition-all duration-300',
          (isMenuOpen || windowWidth < 1024) ? 'h-screen' : 'h-auto',
          'sm:flex md:hidden'
        ]"      
        style="background: linear-gradient(183deg, #1E93FD -15.85%, #3153C7 95.22%);"
      >
        <div class="flex items-center justify-between p-4">
          <img
            src="../assets/main-logo-white.png"
            alt="Mirror Profiles Logo"
            class="w-24 cursor-pointer"
            @click="redirectToAccounts"
          />
          <div class="relative">
            <button @click="isMenuOpen = !isMenuOpen" class="text-white">
              <i class="fas fa-bars fa-2x"></i>
            </button>
            <div 
              v-if="paymentData && !paymentDataFull" 
              class="absolute top-0 right-0 bg-red-500 rounded-full h-3 w-3 transform translate-x-[50%] -translate-y-[50%]"
            ></div>
          </div>
        </div>
  
        <div class="steps flex items-stretch justify-around mt-4 sticky top-0 z-10 p-4"
        >
          <div class="step flex flex-col items-center flex-1 text-center">
            <div
              class="step-circle w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full font-semibold"
              :class="currentStep >= 1 ? (currentStep > 1 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step'"
              >
            <template v-if="currentStep > 1">
              <i class="fas fa-check text-blue-500"></i>
            </template>
            <template v-else>
              1 
            </template>
            </div>
            <p class="text-xs font-medium mt-2 text-center">
              {{ $t('inscrit.step1') }}
            </p>
          </div>
          <div
          class="absolute top-[32%] left-[31%] right-[0] transform -translate-x-1/3 bg-white h-[2px] w-[20%]"
          :class="currentStep >= 2 ? 'bg-blue-500' : 'next-step'"
          ></div>
          <div class="step flex flex-col items-center flex-1 text-center">
            <div
              class="step-circle w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full font-semibold"
              :class="currentStep >= 2 ? (currentStep > 2 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step'"
              >
            <template v-if="currentStep > 2">
              <i class="fas fa-check text-blue-500"></i>
            </template>
            <template v-else>
              2
            </template>
            </div>
            <p class="text-xs font-medium mt-2 text-center">
              {{ $t('inscrit.step2') }}
            </p>
          </div>
          <div
          class="absolute top-[32%] left-[62%] right-[0] transform -translate-x-1/3 bg-white h-[2px] w-[20vw]"
          :class="currentStep >= 3 ? 'bg-blue-500' : 'next-step'"
          ></div>
          <div class="step flex flex-col items-center flex-1 text-center">
            <div
              class="step-circle w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full"
              :class="currentStep >= 3 ? (currentStep > 3 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step'"
              >
            <template v-if="currentStep > 3">
              <i class="fas fa-check text-blue-500"></i>
            </template>
            <template v-else>
              3
            </template>
            </div>
            <p class="text-xs font-medium mt-2 text-center">
              {{ $t('inscrit.step3') }}
            </p>
          </div>
        </div>
  
        <transition name="slide-down">
          <div
            v-if="isMenuOpen"
            class="absolute top-0 left-0 w-full h-full bg-blue-700 text-white flex flex-col p-6 z-20 overflow-auto"
          >
            <button @click="isMenuOpen = false" class="self-end mb-4">
              <i class="fas fa-times fa-2x"></i>
            </button>
            <h1 class="title-checkout mt-10 max-w-lg">
              {{ $t('checkout.title') }}
            </h1>
            
            <transition name="fade" mode="out-in">
              <div v-if="paymentData && !paymentDataFull" class="payment-summary p-6 rounded-lg text-white mt-10 bg-blue-600">
                
                <template v-if="Array.isArray(paymentData) && paymentData.length">
                  <div 
                    v-for="(item, index) in paymentData"
                    :key="index"
                    :class="{
                      'mb-8 pb-4 border-b border-blue-400': index !== paymentData.length - 1,
                      'pb-4': index === paymentData.length - 1
                    }"
                  >
                    <div class="flex items-center justify-between mb-4">
                      <div class="flex items-center space-x-4">
                        <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
                          {{ item.quantity }}
                        </span>
                        <h2 class="text-m font-bold">
                          {{ item.type === 'european' 
                              ? $tc('checkout.europeanAccount', item.quantity) 
                              : $tc('checkout.americanAccount', item.quantity)
                          }}
                        </h2>
                      </div>
                      <div class="text-right flex items-center justify-between">
                        <p class="monthy-price text-sm font-semibold bg-gray-900 text-white px-3 py-1 rounded-lg">
                          {{ $t('checkout.pricePerMonth1') }}
                          {{ item.totalPrice.toFixed(2) }}{{ getCurrencySymbol(item.currency) }}
                          {{ $t('checkout.pricePerMonth2') }}
                        </p>
                      </div>
                    </div>
                    <div class="p-4 rounded-md">
                      <ul class="space-y-2" v-if="item.type === 'european'">
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">
                            {{ $t('checkout.europeProfile') }} <span class="font-bold">{{ $t('checkout.europeProfile2') }}</span>
                          </span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">
                            {{ $t('checkout.europeIp') }} <span class="font-bold">{{ $t('checkout.europeIp2') }}</span>
                          </span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">{{ $t('checkout.warmup') }}</span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">{{ $t('checkout.replacement') }}</span>
                        </li>
                      </ul>
                      <ul class="space-y-2" v-else>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">
                            {{ $t('checkout.usProfile') }} <span class="font-bold">{{ $t('checkout.usProfile2') }}</span> <span class="font-bold">{{ $t('checkout.usProfile3') }}</span>
                          </span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">
                            {{ $t('checkout.usIp') }} <span class="font-bold">{{ $t('checkout.usIp2') }}</span> <span class="font-bold">{{ $t('checkout.usIp3') }}</span>
                          </span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">{{ $t('checkout.warmup') }}</span>
                        </li>
                        <li class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="text-white mr-2">
                            <rect width="16" height="16" rx="2" fill="white" />
                            <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                          </svg>
                          <span class="text-sm text-white">{{ $t('checkout.replacement') }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
  
                <template v-else>
                  <div class="flex items-center justify-between mb-4">
                    <div class="flex items-center space-x-4">
                      <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
                        {{ paymentData.quantity }}
                      </span>
                      <h2 class="text-m font-bold">
                        {{ paymentData.type === 'european' 
                            ? $tc('checkout.europeanAccount', item.quantity) 
                            : $tc('checkout.americanAccount', item.quantity)
                        }}
                      </h2>
                    </div>
                    <div class="text-right flex flex-col items-end">
                      <p class="monthy-price text-sm font-semibold bg-gray-900 text-white px-3 py-1 rounded-lg mt-1">
                        {{ $t('checkout.pricePerMonth1') }} 
                        {{ paymentData.totalPrice.toFixed(2) }}{{ getCurrencySymbol(paymentData.currency) }}
                        {{ $t('checkout.pricePerMonth2') }}
                      </p>
                    </div>
                  </div>
  
                  <div class="p-4 rounded-md">
                    <ul class="space-y-2" v-if="paymentData.type === 'european'">
                      <li class="flex items-center">
                        <svg class="text-white mr-2" width="16" height="16" fill="none">
                          <rect width="16" height="16" rx="2" fill="white" />
                          <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                        </svg>
                        <span class="text-sm text-white">
                          {{ $t('checkout.europeProfile') }} 
                          <span class="font-bold">{{ $t('checkout.europeProfile2') }}</span>
                        </span>
                      </li>
                      <li class="flex items-center">
                        <svg class="text-white mr-2" width="16" height="16" fill="none">
                          <rect width="16" height="16" rx="2" fill="white" />
                          <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                        </svg>
                        <span class="text-sm text-white">
                          {{ $t('checkout.europeIp') }} 
                          <span class="font-bold">{{ $t('checkout.europeIp2') }}</span>
                        </span>
                      </li>
                    </ul>
                    <ul class="space-y-2" v-else>
                      <li class="flex items-center">
                        <svg class="text-white mr-2" width="16" height="16" fill="none">
                          <rect width="16" height="16" rx="2" fill="white" />
                          <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                        </svg>
                        <span class="text-sm text-white">
                          {{ $t('checkout.usProfile') }} 
                          <span class="font-bold">{{ $t('checkout.usProfile2') }}</span> 
                          <span class="font-bold">{{ $t('checkout.usProfile3') }}</span>
                        </span>
                      </li>
                      <li class="flex items-center">
                        <svg class="text-white mr-2" width="16" height="16" fill="none">
                          <rect width="16" height="16" rx="2" fill="white" />
                          <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                        </svg>
                        <span class="text-sm text-white">
                          {{ $t('checkout.usIp') }} 
                          <span class="font-bold">{{ $t('checkout.usIp2') }}</span> 
                          <span class="font-bold">{{ $t('checkout.usIp3') }}</span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </template>
  
              </div>
            </transition>
          </div>
        </transition>
      </div>
  
      <!-- Desktop Version -->
      <div
        class="hidden md:flex w-1/3 flex-col p-responsive text-white sticky top-0"
        style="background: linear-gradient(183deg, #1E93FD -15.85%, #3153C7 95.22%);  height: 100vh;"
      >
        <div class="flex flex-col items-start mb-10 px-6">
          <img
            src="../assets/main-logo-white.png"
            alt="Mirror Profiles Logo"
            class="w-32 mb-4 cursor-pointer"
            @click="redirectToAccounts"
          />
          <h1 class="title-checkout mt-10 max-w-lg">
            {{ $t('checkout.title') }}
          </h1>
        </div>
  
      <div class="grid grid-cols-2 gap-4 px-6 mb-10">
        <div class="flex items-center">
          <img src="../assets/connections.png" alt="Connections" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.connections_label') }}</p>
        </div>
        <div class="flex items-center">
          <img src="../assets/facture.png" alt="Invoices" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.invoices_label') }}</p>
        </div>
        <div class="flex items-center">
          <img src="../assets/warmup.png" alt="Warmup" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.warmup_label') }}</p>
        </div>
        <div class="flex items-center">
          <img src="../assets/service.png" alt="Support" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.support_label') }}</p>
        </div>
        <div class="flex items-center">
          <img src="../assets/engagement.png" alt="No Commitment" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.commitment_label') }}</p>
        </div>
        <div class="flex items-center">
          <img src="../assets/restriction.png" alt="Restriction" class="w-8 h-8 mr-3" />
          <p class="text-data">{{ $t('checkout.restriction_label') }}</p>
        </div>
      </div>


      
      <div class="steps flex items-stretch justify-around mt-4 sticky top-0 z-10  mb-7"
      >
        <div class="step flex flex-col items-center flex-1 text-center">
          <div
            class="step-circle bg-blue-500 w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full font-semibold z-10"
            :class="currentStep >= 1 ? (currentStep > 1 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step'"
            >
          <template v-if="currentStep > 1">
            <i class="fas fa-check text-blue-500"></i>
          </template>
          <template v-else>
            1 
          </template>
          </div>
          <p class="text-lg-desktop font-medium text-white mt-2" style="line-height: 140%;">
            {{ $t('checkout.step1') }}
          </p>
        </div>
        <div
        class="absolute top-[25%] left-[29.5%] right-[0] transform -translate-x-1/3 bg-white h-[2px] w-[25%]"
        :class="[
            currentStep >= 2 ? 'bg-blue-500' : 'next-step-trait',
            isBig ? 'top-[25%]' : 'top-[29%]'
          ]"
        ></div>
        <div class="step flex flex-col items-center flex-1 text-center z-5">
          <div
            class="step-circle w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full font-semibold z-10 "
            :class="currentStep >= 2 ? (currentStep > 2 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step bg-colorstable'"
            >
          <template v-if="currentStep > 2">
            <i class="fas fa-check text-blue-500"></i>
          </template>
          <template v-else>
            2
          </template>
          </div>
          <p class="text-lg-desktop font-medium mt-2" :class="currentStep >= 2 ? 'text-white' : 'next-step'" style="line-height: 140%;">
            {{ $t('checkout.step2') }}
          </p>
          </div>
        <div
        class="absolute top-[25%] left-[62.8%] right-[0] transform -translate-x-1/3 bg-white h-[2px] w-[25%]"
        :class="[
            currentStep >= 3 ? 'bg-blue-500' : 'next-step-trait',
            isBig ? 'top-[25%]' : 'top-[29%]'
          ]"
        ></div>
        <div class="step flex flex-col items-center flex-1 text-center">
          <div
            class="step-circle w-8 h-8 border-2 border-white text-white flex items-center justify-center rounded-full z-10"
            :class="currentStep >= 3 ? (currentStep > 3 ? 'bg-white border-transparent' : 'bg-blue-500 border-white') : 'next-step bg-colorstable'"
            >
          <template v-if="currentStep > 3">
            <i class="fas fa-check text-blue-500"></i>
          </template>
          <template v-else>
            3
          </template>
          </div>
          <p class="font-medium mt-2 text-lg-desktop " :class="currentStep >= 3 ? 'text-white' : 'next-step'" style="line-height: 140%;">
            {{ $t('checkout.step3') }}
          </p>
        </div>
      </div>

        <div class="flex flex justify-center">
          <div class="w-[80%] demo-container p-6 mt-8"
            v-if="!paymentData" 
          > 
          <div class="demo-text">
            {{ $t('checkout.question') }}
          </div>
          <div class="flex w-full items-center gap-2 mt-5">
            <button class="w-[80%] h-[50px] demo-button" @click="openDemo">
              {{ $t('checkout.cta') }}
            </button>

            <button class="w-[50px] h-[50px] demo-video" @click="openModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                <g clip-path="url(#clip0_543_1891)">
                  <path d="M3.26 0.670001L7.59 5H0.0899999C0.243044 4.08067 0.609555 3.21004 1.1601 2.45804C1.71063 1.70604 2.42986 1.09363 3.26 0.670001ZM9.08 4.72357e-07H6C5.81 4.72357e-07 5.62 0.0100005 5.43 0.0200005L10.41 5H14.08L9.08 4.72357e-07ZM16 4.72357e-07H11.92L16.92 5H21.91C21.6757 3.60207 20.9533 2.33251 19.8712 1.41702C18.7891 0.501533 17.4174 -0.000562172 16 4.72357e-07ZM9.4819 16.626L14.4819 13.876C14.6389 13.7899 14.7699 13.6631 14.8611 13.509C14.9523 13.3549 15.0005 13.1791 15.0005 13C15.0005 12.8209 14.9523 12.6451 14.8611 12.491C14.7699 12.3369 14.6389 12.2101 14.4819 12.124L9.4819 9.374C9.32965 9.29027 9.15821 9.24765 8.98447 9.25035C8.81074 9.25305 8.64071 9.30096 8.49113 9.38938C8.34155 9.4778 8.21759 9.60367 8.13147 9.75458C8.04535 9.9055 8.00004 10.0762 8 10.25V15.75C8.00004 15.9238 8.04535 16.0945 8.13147 16.2454C8.21759 16.3963 8.34155 16.5222 8.49113 16.6106C8.64071 16.699 8.81074 16.747 8.98447 16.7497C9.15821 16.7523 9.32965 16.7097 9.4819 16.626ZM22 7V16C21.9987 17.5909 21.3662 19.1163 20.2412 20.2412C19.1163 21.3662 17.5909 21.9987 16 22H6C4.40909 21.9987 2.88371 21.3662 1.75876 20.2412C0.633821 19.1163 0.0012712 17.5909 0 16V7H22Z" fill="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_543_1891">
                    <rect width="22" height="22" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
        </div>
        
  
        <transition name="fade" mode="out-in">
          <div 
            v-if="paymentData && Array.isArray(paymentData) && paymentData.length" 
            :class="['payment-summary', currentStep >= 9 ? 'paid' : '']"
            class="p-6 rounded-lg text-white bg-blue-600 relative"
          >
            <div v-if="currentStep >= 9" class="paid-badge absolute top-0 left-[3rem] transform -translate-y-1/2 -translate-x-1/2">
              {{ $t('inscrit.paye') }}
            </div>

            <div class="overflow-y-auto max-h-[20vh] pr-2 relative shadow-inner scrollbar-custom scrollbar-hidden">
              <div 
                v-for="(item, index) in paymentData" 
                :key="index" 
                :class="{
                  'mb-8': index+1 !== paymentData.length,
                  'mb-3': index+1 === paymentData.length 
                }"          
              >
                <div class="flex items-center justify-between mb-4">
                  <div class="flex items-center space-x-4">
                    <span class="quantity-display text-white px-4 py-1 rounded-full font-bold">
                      {{ item.quantity }}
                    </span>
                    <h2 class="text-m font-bold">
                      {{ item.type === 'european' 
                          ? $tc('checkout.europeanAccount', item.quantity) 
                          : $tc('checkout.americanAccount', item.quantity)
                      }}
                    </h2>
                  </div>
                  <div class="text-right flex items-center justify-between">
                    <p class="monthy-price text-[1vw] font-semibold bg-gray-900 text-white px-3 py-1 rounded-lg">
                      {{ $t('checkout.pricePerMonth1') }}
                      {{ item.totalPrice.toFixed(2) }}{{ getCurrencySymbol(item.currency) }}
                      {{ $t('checkout.pricePerMonth2') }}
                    </p>
                  </div>
                </div>
                <div class="p-4 pt-1 pb-0 rounded-md">
                  <ul class="space-y-2" v-if="item.type === 'european'">
                    <li class="flex items-center">
                      <svg class="text-white mr-2" width="16" height="16" fill="none">
                        <rect width="16" height="16" rx="2" fill="white" />
                        <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                      </svg>
                      <span class="text-sm text-white">
                        {{ $t('checkout.europeProfile') }} 
                        <span class="font-bold">{{ $t('checkout.europeProfile2') }}</span>
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg class="text-white mr-2" width="16" height="16" fill="none">
                        <rect width="16" height="16" rx="2" fill="white" />
                        <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                      </svg>
                      <span class="text-sm text-white">
                        {{ $t('checkout.europeIp') }} 
                        <span class="font-bold">{{ $t('checkout.europeIp2') }}</span>
                      </span>
                    </li>
                  </ul>
                  <ul class="space-y-2" v-else>
                    <li class="flex items-center">
                      <svg class="text-white mr-2" width="16" height="16" fill="none">
                        <rect width="16" height="16" rx="2" fill="white" />
                        <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                      </svg>
                      <span class="text-sm text-white">
                        {{ $t('checkout.usProfile') }} 
                        <span class="font-bold">{{ $t('checkout.usProfile2') }}</span> 
                        <span class="font-bold">{{ $t('checkout.usProfile3') }}</span>
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg class="text-white mr-2" width="16" height="16" fill="none">
                        <rect width="16" height="16" rx="2" fill="white" />
                        <path d="M6 10.5L3.5 8L2.5 9L6 12.5L13.5 5L12.5 4L6 10.5Z" fill="#1E93FD" />
                      </svg>
                      <span class="text-sm text-white">
                        {{ $t('checkout.usIp') }} 
                        <span class="font-bold">{{ $t('checkout.usIp2') }}</span> 
                        <span class="font-bold">{{ $t('checkout.usIp3') }}</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="paymentDataFull && paymentDataFull.paymentDataWithAddons && paymentDataFull.paymentDataWithAddons.addons.length" class="mt-6">
                <h3 style="color:white;" class="text-m font-bold pt-4 font-semibold border-t border-blue-400">
                  {{ $t('checkout.addonsSelected') }}
                </h3>
                <div 
                  v-for="(addon, index) in paymentDataFull.paymentDataWithAddons.addons" 
                  :key="index"
                  :class="{
                    'pb-4': index !== paymentDataFull.paymentDataWithAddons.addons.length,
                    'pb-0': index === paymentDataFull.paymentDataWithAddons.addons.length
                  }"
                >
                  <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-4">
                      <img :src="getAddonLogo(addon.name)" alt="Logo" class="h-8 p-1 filter" />
                    </div>
                    <div class="text-right flex items-center justify-between">
                      <p v-if="!isBannedAddon(addon.name)" class="monthy-price text-sm font-semibold bg-gray-900 text-white px-3 py-1 rounded-lg">
                        {{ $t('checkout.pricePerMonth1') }}
                        {{ addon.totalPrice.toFixed(2) }}{{ getCurrencySymbol(paymentDataFull.currency) }}
                        {{ $t('checkout.pricePerMonth2') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="paymentDataFull && paymentDataFull.paymentDataWithAddons && paymentDataFull.paymentDataWithAddons.addons.length" class="mt-6 pt-4 border-t border-blue-400 text-lg font-bold flex justify-between items-center">
                <span>{{ $t('checkout.totalPrice') }}</span>
                <span class="text-white">
                  {{ $t('checkout.pricePerMonth1') }} {{ getTotalPrice() }}{{ getCurrencySymbol(paymentDataFull.currency) }} {{ $t('checkout.pricePerMonth2') }}
                </span>
              </div>
          </div>
        </transition>
      </div>
      <div class="flex-1">
        <router-view />
      </div>
      
    </div>
  </template>
  
  <script>
    import heyreach from '../assets/heyreach-logo-white.png'
    import mirrorchat from '../assets/mirrorchat-logo-white.png'
    import getSales from '../assets/getSales-logo-white.png'
    import custom from '../assets/custom-Logo.png'
    import salesNav from '../assets/SalesNav-logo-white.png'

  export default {
    name: 'SideBarLayout',
    data() {
      return {
        currentStep: parseInt(localStorage.getItem('currentStep')) || 1,
        paymentData: JSON.parse(localStorage.getItem('paymentData')) || null,
        paymentDataFull: JSON.parse(localStorage.getItem('paymentDataFull')) || null,
        isMobile: false,
        isMenuOpen: false,
        showModal: false,
        embedUrl: '',
        isBig: false,
        videos: {
          fr: 'https://www.youtube.com/watch?v=93YRCNq8jpQ',
          en: 'https://youtu.be/eifVtQeerUM',
        },
        demos: {
          fr: 'https://mirrorprofiles.com/demo/',
          en: 'https://mirrorprofiles.com/en/demo/',
        },
        addontable: {
            "HeyReach Business": heyreach,
            "MirrorChat": mirrorchat,
            "Custom Branding": custom,
            "Get Sales.io": getSales,
            "Sales Navigator": salesNav,
        },
      };
    },
    watch: {
      currentStep(newStep) {
        localStorage.setItem('currentStep', newStep);
      },
      paymentData(newData) {
        if (newData) {
          localStorage.setItem('paymentData', JSON.stringify(newData));
        } else {
          localStorage.removeItem('paymentData');
        }
      },
      paymentDataFull(newData) {
        if (newData) {
          localStorage.setItem('paymentDataFull', JSON.stringify(newData));
        } else {
          localStorage.removeItem('paymentDataFull');
        }
      },
    },
    mounted() {
      this.updateIsMobile();
      window.addEventListener("resize", this.updateIsMobile);
      const storedPaymentData = localStorage.getItem('paymentData');
      if (storedPaymentData) {
        this.paymentData = JSON.parse(storedPaymentData);
      }
  
      const storedPaymentDataFull = localStorage.getItem('paymentDataFull');
      if (storedPaymentDataFull) {
        this.paymentDataFull = JSON.parse(storedPaymentDataFull);
      }
  
      const storedCurrentStep = localStorage.getItem('currentStep');
      if (storedCurrentStep) {
        this.currentStep = parseInt(storedCurrentStep);
      }
  
      window.addEventListener('storage', this.handleStorageChange);
    },
    beforeUnmount() {
      window.removeEventListener('storage', this.handleStorageChange);
    },
    methods: {

      selectedVideo() {
        var currentLanguage = localStorage.getItem('langue') || navigator.language;
        return currentLanguage.startsWith('fr')
          ? this.videos.fr
          : this.videos.en;
      },
      selectedDemo() {
        var currentLanguage = localStorage.getItem('langue') || navigator.language;
        return currentLanguage.startsWith('fr')
          ? this.demos.fr
          : this.demos.en;
      },
      openModal() {
      const videoId = this.extractYouTubeId(this.selectedVideo());
        if (videoId) {
          this.embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
          this.showModal = true;
        } else {
          console.error('Impossible de trouver l’ID de la vidéo YouTube.');
        }
      },
      closeModal() {
        this.showModal = false;
        this.embedUrl = '';
      },

      openDemo() {
        window.open(this.selectedDemo(), "_blank");
      },

      extractYouTubeId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return match && match[2].length === 11 ? match[2] : null;
      },

      isBannedAddon(addonName) {
        const bannedAddons = ["HeyReach Business", "Get Sales.io"];
        return bannedAddons.includes(addonName);
      },

      getAddonLogo(key) {
          return this.addontable[key] || null; 
      },

      getCurrencySymbol(currency) {
        if (!currency) return '';
        const symbols = {
          eur: '€',
          usd: '$',
        };
        return symbols[currency.toLowerCase()] || currency.toUpperCase();
      },
      getTotalPrice() {
          let total = 0;

          if (this.paymentDataFull && this.paymentDataFull.paymentData) {
              total += this.paymentDataFull.paymentData.reduce((sum, item) => sum + item.totalPrice, 0);
          }

          if (this.paymentDataFull && this.paymentDataFull.paymentDataWithAddons && this.paymentDataFull.paymentDataWithAddons.addons) {
              total += this.paymentDataFull.paymentDataWithAddons.addons
                  .filter(addon => !this.isBannedAddon(addon.name)) 
                  .reduce((sum, addon) => sum + addon.totalPrice, 0);
          }

          return total.toFixed(2);
      },
      updateIsMobile() {
          this.isMobile = window.innerWidth <= 900; 
          this.isBig = window.innerWidth <= 1420; 
        },
      handleStorageChange(event) {
        if (event.key === 'paymentData') {
          this.paymentData = event.newValue ? JSON.parse(event.newValue) : null;
        }
        if (event.key === 'paymentDataFull') {
          this.paymentDataFull = event.newValue ? JSON.parse(event.newValue) : null;
        }
        if (event.key === 'currentStep') {
          this.currentStep = event.newValue ? parseInt(event.newValue) : 1;
        }
      },
      redirectToAccounts() {
        window.location.href = 'https://mirrorprofiles.com/';
      },
    },
  };
  </script>
  
  
  
  <style scoped>
  .scrollbar-hidden::-webkit-scrollbar-thumb {
    background: transparent;
  }

  .scrollbar-hidden:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(255, 255, 255, 0.3);
  }

  .scrollbar-hidden::-webkit-scrollbar-track {
    background: transparent;
  }

  .scrollbar-custom::-webkit-scrollbar {
    width: 8px;
  }

  .scrollbar-custom::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(255, 255, 255, 0.3);
  }

  .scrollbar-custom::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
  }

  .scrollbar-custom:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.8);
  }
        .title-checkout{
        color: #FFF;
        font-family: Montserrat, sans-serif;
        font-size: clamp(20px, 1.5vw, 23px);
        font-style: normal;
        font-weight: 700;
        line-height: 140%;
      }
  
      .step-circle {
          width: 3rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 2px solid white;
          border-radius: 50%;
          color: white;
          font-weight: bold;
        }
        .next-step {
          color: #95b4ec;
          border-color: #95b4ec; 
        }

        .next-step-trait {
          background-color:#95b4ec;
        }
  
        .fade-enter-active,
        .fade-leave-active {
          transition: opacity 0.5s ease;
        }
  
        .fade-enter {
          opacity: 0;
        }
  
        .fade-leave-to {
          opacity: 0;
        }
        .step-circle {
          transition: background-color 0.3s, border-color 0.3s;
        }
        .text-lg {
          transition: color 0.3s;
        }
        .payment-summary{
          background: #0E51AC;
        }
  
        .monthy-price{
          border-radius: 4px;
          background: #083879;
        }
  
        .quantity-display{
          border-radius: 5px;
          background: #1E93FD;
        }
  
  
        .text-lg-desktop{
          font-family: Montserrat;
          font-size: clamp(12px, 1.5vw, 16px);
          font-style: normal;
          font-weight: 600;
          line-height: 140%; 
        }
  
        .p-responsive {
          padding: 1rem; 
        }

        .text-data{
          color: #FFF;
          font-family: Montserrat;
          font-size: 15.633px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }

        @media (min-width: 1500px) {
          .p-responsive {
            padding: 1rem; 
            padding-top: 2rem; 
          }
          .text-data{
            color: #FFF;
            font-family: Montserrat;
            font-size: 15.633px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
          }
        }
  
        
        .payment-summary.paid {
          border-radius: 8px;
          border: 3px solid #53FFAC;
        }

        .paid-badge {
          padding: 4px 8px;
          background-color: #53FFAC;
          color: #ffffff;
          font-weight: bold;
          border-radius: 4px;
          color: #003E93;
          font-family: Montserrat, sans-serif;
          font-size: 13px;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
        }

        .demo-container{
          border-radius: 10px;
          border: 2px solid #FFF;
        }

        .demo-text{
          color: #FFF;
          font-family: Montserrat;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 140%; /* 28px */
        }

        .demo-button{
          border-radius: 50px;
          font-weight: bold; 
          text-align: center; 
          font-size: 16px;
          border: 2px solid #FFF;
        }

        .demo-button span{
          -webkit-text-fill-color:#FFF; 
        }


        .demo-button:hover {
          background: #FFF;
          color: #3154C8;
          border: 2px solid #3154C8;
        }


        .demo-button:hover span {
          background-image: linear-gradient(90deg, #1E93FD 0%, #3154C8 100%); 
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent; 
        }

        .demo-video {
          border-radius: 50%; 
          font-weight: bold; 
          text-align: center; 
          font-size: 16px;
          border: 2px solid #FFF;
          display: flex;
          justify-content: center;
          align-items: center;
          aspect-ratio: 1 / 1; 
          padding: 0; 
        }

        .demo-video svg {
          width: 24px;
          height: 24px;
          -webkit-text-fill-color: #FFF;
        }

        .demo-video:hover {
          background-color: #FFF;
          border-color: #3154C8;
          
        }

        .demo-video:hover svg path {
          fill: #3154C8; /* ta couleur souhaitée au hover */
        }

        .bg-colorstable {
          --tw-bg-opacity: 1;
          background-color: #2b68d9;
        }

  </style>
  
  
  